import Dialog from './_dialog.js'
import Popup from './_popup.js'
import ScrollPane from './_scroll-pane.js'
import FlexPane from './_flex-pane.js'

export default {
  name: 'QuickNavigationPane',
  values: {
    showDialog: false,
    _mobile_showDialog: true,
    dialog: {
      configSet: Dialog,
      configValues: {
        _mobile_layoutType: 'centered',
        contentContainer: {
          padding: '4px',
        },
        overlay: {
          style: {
            container: {
              alignItems: 'flex-start',
            },
          },
        },
        centered: {
          width: 'calc(100% - 32px)',
          maxWidth: '400px',
          minWidth: '280px',
          maxHeight: 'min(840px, 100%)',
          height: 'auto',
          padding: '88px 0 40px 0',
          boxSizing: 'border-box',
        },
        closeButtonContainer: {
          style: {
            right: '0px',
            _mobile_top: '40px',
          },
        },
        closeButton: {
          buttonIcon: {
            style: {
              minWidth: '16px',
              minHeight: '16px',
            },
          },
        },
      },
    },
    popup: {
      configSet: Popup,
      configValues: {
        isOverlayMode: false,
        _mobile_isOverlayMode: true,
        showArrowHead: false,
        container: {
          style: {
            width: '400px',
            maxHeight: '464px',
            top: '40px',
            left: '36px',
            zIndex: 800,
            padding: '0',
          },
        },
        content: {
          enableTransitions: false,
          style: {
            base: {
              flexDirection: 'column',
              padding: '4px',
            },
          },
        },
      },
    },
    scrollPane: {
      configSet: ScrollPane,
      configValues: {
        direction: 'y',
        scrollBarWidth: 'thin',
      },
    },
    quickNavigationContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          display: 'block',
          width: '100%',
          maxHeight: '472px',
          height: '100%',
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
